import { useHistory } from "react-router-dom";
import { DASHBOARD_PATH } from "constants/Routes.constants";

export const useRedirectPath = () => {
  const history = useHistory();
  const { pathname, search } = history.location || {};
  return pathname.replace(DASHBOARD_PATH, "?redirect=") + search.replace("?", "&");
};
